import type { canv } from "@/canv/global";
import { PresentationWidget } from "@/elements/Presentation/Presentation";

export function renamePresentation(name: string, canvInstance: typeof canv) {
    const selectedEntities = canvInstance.canvasController.selected;

    if (selectedEntities.length === 1 && selectedEntities[0].isItemWrapper()) {
        const child = selectedEntities[0].onlyChild();
        if (child && child instanceof PresentationWidget) {
            const newName = name.trim();
            const input = document.querySelector<HTMLInputElement>(".presentationNameInputField");
            if (newName) {
                if (input) input.value = newName;
                child.setName(newName);
            } else {
                canvInstance.widgetMenu.reopen();
            }
        }
    }
}
